<template>
  <el-dialog title="提交对账" :visible.sync="billDialogVisible" center @before-close="dialogBillClose" :close-on-click-modal="false">
    <div class="nav">
      <div class="navContainer" style="width: 300px">
        <p style="width: 120px; display: inline-block; text-align: right">对账单编号：</p>
        <el-input v-model="billData.settNo" size="mini" style="width: 160px" placeholder="请输入对账单编号" />
      </div>
      <div class="navContainer" style="width: 300px; margin: -29px 0 0 280px">
        <p style="width: 60px; display: inline-block; text-align: right">标题：</p>
        <el-input v-model="billData.title" size="mini" style="width: 200px" placeholder="请输入标题" />
      </div>
      <div class="navBtn" style="display: flex; justify-content: flex-end; margin: -30px 0 10px">
        <el-button size="small" class="searchBtn" @click="billSearchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="billResetBtn">重置</el-button>
        <el-button size="small" class="submit" @click="submit">确认</el-button>
      </div>
    </div>
    <div class="tableContent">
      <el-table ref="billRef" :data="billTable.table" v-loading="billTableLoad" style="width: 100%" border :header-cell-style="headerCellStyle" highlight-current-row @current-change="handleCurrentChange">
        <el-table-column align="center" width="50px">
          <template v-slot="{ row, $index }">
            <el-radio v-model="radioId" :label="row.id" @change="val => handleChange(val, row.id)">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column property="settNo" align="center" label="对账单编号" width="139"></el-table-column>
        <el-table-column property="title" align="center" label="标题" width="130"></el-table-column>
        <el-table-column property="companyNameNew" align="center" label="公司" width="140"></el-table-column>
        <el-table-column label="合计含税费用" align="center">
          <template slot-scope="scope" style="display: flex; align-items: center; justify-content: center">
            <div>
              <span v-if="scope.row.settType === 1">{{ scope.row.taxPrice }}</span>
              <span v-else-if="scope.row.settType === 2">{{ scope.row.taxSettPrice }}</span>
              <span v-else>{{ scope.row.taxPrice != null && scope.row.taxPrice > 0 ? scope.row.taxPrice : scope.row.taxSettPrice }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="合计不含税费用" align="center">
          <template slot-scope="scope" style="display: flex; align-items: center; justify-content: center">
            <div>
              <span v-if="scope.row.settType === 1">{{ scope.row.noTaxPrice }}</span>
              <span v-else>{{ scope.row.noTaxSettPrice }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="paginationContainer" style="margin-top: 10px">
      <span>共{{ billDataTotal }}条</span>
      <el-pagination :page-sizes="[100, 200, 300, 400]" :page-size="100" layout=" sizes, prev, pager, next, jumper" :total="billDataTotal" @size-change="billSizeChange" @current-change="billCurrentChange" />
    </div>
  </el-dialog>
</template>
<script>
  import { getReconciliationList, mergeReconciliation } from '@/service/contract';
  import { number } from 'echarts/lib/export';

  export default {
    computed: {
      number() {
        return number;
      },
    },
    data() {
      return {
        billDialogVisible: false,
        dialogBillClose: false,
        billData: {
          settlementId: '', //行数据id
          companyName: '',
          title: '',
          settNo: '',
        },
        billTable: {
          table: [],
          title: '',
        },
        billTableLoad: false,
        headerCellStyle: {
          color: '#3B3B3B',
          'font-size': '13px',
          height: '90px',
          background: '#E8E8E8',
        },
        billDataTotal: 0,
        radioId: '',
      };
    },
    methods: {
      dialogOpen(row) {
        this.billDialogVisible = true;
        this.billData.settlementId = row.id;
        this.billData.companyId = row.companyId;
        this.billData.companyName = row.companyName;
        this.billSearch();
      },
      //查询
      async billSearch() {
        this.billTableLoad = true;
        let obj = {
          companyName: this.billData.companyName,
          // companyId: this.billData.companyId,
          title: this.billData.title,
          settNo: this.billData.settNo,
          page: 1,
          size: 10,
        };
        const res = await getReconciliationList(obj);
        this.billTableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.billTable.table = res.data.records;
        this.billDataTotal = res.data.total;
      },
      billSearchBtn() {
        this.billSearch();
      },
      //重置
      billResetBtn() {
        this.billData.settNo = '';
        this.billData.title = '';
      },
      //确认
      async submit() {
        const oilId = this.billData.settlementId;
        const settlementId = this.id;
        this.$confirm(`确认选择该对账单？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          const { status, message } = await mergeReconciliation(oilId, settlementId);
          if (status !== 0) return this.$message.warning(message);
          this.$message.success(message);
          this.billDialogVisible = false;
          this.dialogBillClose();
        });
      },
      handleChange(id, idx) {
        this.id = idx;
      },
      //单选
      handleCurrentChange(val) {
        this.currentRow = val;
      },
      billSizeChange(sizes) {
        this.billData.size = sizes;
      },
      billCurrentChange(page) {
        this.billData.page = page;
      },
    },
  };
</script>
<style scoped lang="scss">
  .el-pagination {
    white-space: nowrap;
    margin: -22px 43px 10px;
    color: #303133;
    font-weight: 700;
  }
</style>
